import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "voice-settings-box"
};
const _hoisted_2 = {
  class: "voice-settings-icon-mask"
};
const _hoisted_3 = {
  class: "voice-settings-control-panel"
};
const _hoisted_4 = {
  class: "voice-settings-control-name"
};
const _hoisted_5 = {
  key: 0,
  class: "voice-settings-control-main-name"
};
const _hoisted_6 = {
  class: "voice-settings-control-desc"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "dialog-content"
};
const _hoisted_9 = {
  class: "voice-selector-box"
};
const _hoisted_10 = ["onClick", "onDblclick"];
const _hoisted_11 = {
  class: "voice-item-name"
};
const _hoisted_12 = {
  class: "voice-item-name-main"
};
const _hoisted_13 = {
  class: "voice-item-name-sub"
};
const _hoisted_14 = {
  class: "voice-details"
};
const _hoisted_15 = ["src"];
import { Mic } from '@element-plus/icons-vue';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { describeTimbre } from '@/request/index';
import TimbreEditor from './TimbreEditor.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    selectedVoice: {
      type: Object,
      default: () => ({})
    },
    platformId: {
      type: String,
      default: ''
    },
    voiceId: {
      type: String,
      default: ''
    }
  },
  emits: ['update:selectedVoice'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const voicePlayer = ref(null);
    const voicePlaying = ref(false);
    const selectedVoiceItem = computed({
      get: () => props.selectedVoice,
      set: val => emits('update:selectedVoice', val)
    });
    const voiceList = ref([]);
    const dialogVisible = ref(false);
    const tempSelectedVoice = ref({});
    const tempVoicePlayer = ref(null);
    const tempVoicePlaying = ref(false);
    const openVoiceSelector = () => {
      var _voicePlayer$value;
      (_voicePlayer$value = voicePlayer.value) === null || _voicePlayer$value === void 0 || _voicePlayer$value.pause();
      voicePlaying.value = false;
      dialogVisible.value = true;
    };
    const cancelSelectVoice = () => {
      dialogVisible.value = false;
      tempSelectedVoice.value = {};
      resetTempVoicePlayer();
    };
    const comfirmSelectVoice = () => {
      if (Object.keys(tempSelectedVoice.value).length == 0) {
        return ElMessage.warning('请先选择音色');
      }
      dialogVisible.value = false;
      selectedVoiceItem.value = tempSelectedVoice.value;
      console.log(selectedVoiceItem.value, tempSelectedVoice.value, '确认');
      tempSelectedVoice.value = {};
      resetTempVoicePlayer();
    };
    const resetTempVoicePlayer = () => {
      if (tempVoicePlayer.value) {
        tempVoicePlayer.value.pause();
        tempVoicePlayer.value.currentTime = 0;
      }
    };
    const handleEmotionClick = emotion => {
      tempSelectedVoice.value.extendId = (emotion === null || emotion === void 0 ? void 0 : emotion.id) || '';
    };
    const handleVoiceItemClick = voice => {
      tempSelectedVoice.value = voice;
      resetTempVoicePlayer();
      nextTick(() => {
        var _tempVoicePlayer$valu;
        return (_tempVoicePlayer$valu = tempVoicePlayer.value) === null || _tempVoicePlayer$valu === void 0 ? void 0 : _tempVoicePlayer$valu.play();
      });
    };
    const quickSelectVoice = voice => {
      tempSelectedVoice.value = voice;
      comfirmSelectVoice();
    };
    const getVoiceData = () => {
      describeTimbre({
        pageIndex: 1,
        pageSize: 200
      }).then(res => {
        const {
          code,
          data,
          msg
        } = res.data;
        if (code == 200) {
          voiceList.value = data.list;
          // .filter((item: any) => !props.platformId || item.platformId == props.platformId);
          if (props.voiceId) {
            selectedVoiceItem.value = voiceList.value.find(item => item.id == props.voiceId) || {};
          }
        }
      });
    };
    watch(() => props.platformId, newVal => {
      getVoiceData();
    });
    onMounted(() => {
      getVoiceData();
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(['voice-settings-icon-box', {
          playing: voicePlaying.value
        }]),
        onClick: openVoiceSelector
      }, [_createVNode(_component_svg_icon, {
        class: "voice-settings-icon-svg",
        width: "100%",
        height: "100%",
        "icon-class": "dvd"
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(Mic), {
        class: "voice-settings-icon-mask-icon"
      })])], 2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [selectedVoiceItem.value.timbreName ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(selectedVoiceItem.value.timbreName), 1)) : _createCommentVNode("", true), selectedVoiceItem.value.timbreName ? (_openBlock(), _createBlock(_component_el_divider, {
        key: 1,
        direction: "vertical"
      })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_6, _toDisplayString(selectedVoiceItem.value.timbreDesc || '点击左侧图标选择音色'), 1)]), _createElementVNode("audio", {
        class: "voice-settings-control-audio",
        ref_key: "voicePlayer",
        ref: voicePlayer,
        controls: "",
        src: selectedVoiceItem.value.timbreSample,
        onPlay: _cache[0] || (_cache[0] = $event => voicePlaying.value = true),
        onPause: _cache[1] || (_cache[1] = $event => voicePlaying.value = false),
        onEnded: _cache[2] || (_cache[2] = $event => voicePlaying.value = false)
      }, null, 40, _hoisted_7)]), dialogVisible.value ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogVisible.value = $event),
        title: "选择音色",
        width: "1000",
        "before-close": cancelSelectVoice,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: cancelSelectVoice
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: comfirmSelectVoice
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("确定")])),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_scrollbar, {
          height: "550px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(voiceList.value, voice => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['voice-item', {
                active: tempSelectedVoice.value.id === voice.id,
                playing: tempVoicePlaying.value && tempSelectedVoice.value.id === voice.id
              }]),
              key: voice.id,
              onClick: $event => handleVoiceItemClick(voice),
              onDblclick: $event => quickSelectVoice(voice)
            }, [_createElementVNode("div", {
              class: "voice-item-icon",
              onClick: openVoiceSelector
            }, [_createVNode(_component_svg_icon, {
              class: "voice-item-icon-svg",
              width: "100%",
              height: "100%",
              "icon-class": "dvd"
            })]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(voice.timbreName), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(voice.timbreDesc || '点击左侧图标选择音色'), 1)])], 42, _hoisted_10);
          }), 128))])]),
          _: 1
        }), _createElementVNode("div", _hoisted_14, [_createVNode(TimbreEditor, {
          selectedVoice: tempSelectedVoice.value,
          onHandleEmotionClick: handleEmotionClick
        }, null, 8, ["selectedVoice"])])])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _createElementVNode("audio", {
        ref_key: "tempVoicePlayer",
        ref: tempVoicePlayer,
        src: tempSelectedVoice.value.timbreSample,
        onPlay: _cache[4] || (_cache[4] = $event => tempVoicePlaying.value = true),
        onPause: _cache[5] || (_cache[5] = $event => tempVoicePlaying.value = false),
        onEnded: _cache[6] || (_cache[6] = $event => tempVoicePlaying.value = false)
      }, null, 40, _hoisted_15)]);
    };
  }
});